import React, { useEffect, useState } from "react";
import { decodeToken } from "react-jwt";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import * as pageRoutes from "../../pageRoutes";
import { apiCall, commonApiCall } from "../common/common";
import { useNavigate } from "react-router-dom";
import Loader from "../common/Loader";
import {
  loginApi,
  passResetApi,
  confirmPassResetApi,
  tenantInfoApi,
  ssoUrl,
  ssoRedirectUrl,
  ssoClientId,
} from "../common/constants";
import {
  setLocalStorageValue,
  removeValueFromLocalStorage,
  getLocalStorageValue,
  setCompanyDateFromLocalStorage,
} from "../../utils/localStorageOperations";
import { checkSessionStatus } from "../../utils/loginSessionOperations";
import { ssoLogin } from "./sso/SsoService"

import "./login.scss";
import LoginFooter from "./LoginFooter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import config from "../../config/config";

const errorMsgs = {
  email: "Email is incorrect",
  password: "Pasword is incorrect",
  both: "Email or Password is incorrect",
  fortgotBoth: "Code or Password is incorrect",
  valid: ["Email is required", "Password is required"],
  validEmail: ["Valid Email is required"],
};

const Login = (props) => {
  const navigate = useNavigate();
  const [loginForm, setLoginForm] = useState(true);
  const [resetPassForm, setResetPassForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [passwordType, setPasswordType] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [state, setState] = useState({
    email: "",
    password: "",
    code: "",
  });
  

  console.log('config.ssoRedirectUrl', config.ssoRedirectUrl);
  const socialLogin = async (data) => {
    const apiData = await commonApiCall("GET", "sso-details", {}, { client: data });
    const ssoDetails = apiData.data;
    const ssoRedirect = `${ssoDetails.authUrl}?redirect_uri=${config.ssoRedirectUrl}&response_type=TOKEN&client_id=${ssoDetails.clientId}&scope=aws.cognito.signin.user.admin email openid phone profile`
    window.location.replace(ssoRedirect)
  }

  useEffect(() => {
    const hash = window.location.hash
    if (hash && (loading == false)) {
        const unhashed = hash.charAt(0) === "#" ? hash.substring(1) : hash
        const urlParams = new URLSearchParams(unhashed)
        const accessToken = urlParams.get("access_token")
        const idToken = urlParams.get("id_token")
        if (accessToken && idToken) {
          ssoLogin({ accessToken, idToken });
          setLoading(true);
        }
    } else if (localStorage.email) {
      window.location.href = "/dashboard"
    }
  }, [loading]);

  return (<>
    <Loader loading={loading} doNotOverFlow={true} />
    <div className="auth-wrapper">
      <div className="container-fluid">
        <div className="row align-items-center justify-content-center loginPage">
          <div className="col-4">
            <div className="login-logo"></div>
            <div className="row pad">
              <div className="col-md-12 text-start">
                <ul id="signinErrorList">
                  {Array.isArray(errorMsg)
                    ? errorMsg.map((ele) => (
                        <li className="alert alert-danger">{ele}</li>
                      ))
                    : errorMsg && (
                        <li className="alert alert-danger">{errorMsg}</li>
                      )}
                  {Array.isArray(successMsg)
                    ? successMsg.map((ele) => (
                        <li className="alert alert-success">{ele}</li>
                      ))
                    : successMsg && (
                        <li className="alert alert-success">{successMsg}</li>
                      )}
                </ul>
                <h1 className="display-4 text-left mb-3 fw-bolder">
                  Hello Again!
                </h1>
                <p className="text-muted text-left mb-5">
                  Sign In to access <b>CMT</b>
                </p>
                <div className="d-grid">
                    <button className="btn btn-outline-info" onClick={() => socialLogin("azure")}>
                        <img height={15} className="mb-1" src={process.env.PUBLIC_URL + "/images/azure-logo.png"} alt="logo" /> Sign in with Azure
                    </button>
                </div>
              </div>
              <div className="col-md-12 mt-5">
                <img
                  className="float-start me-2"
                  src="data:image/png;base64,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"
                />
                <div className="mt-2">
                  <small>
                    To ensure you have the best possible experience using
                    Bungee Retailscape, we recommend to use Chrome version
                    91 or above
                  </small>
                </div>
              </div>
              <div className="col-md-12">
                <p className="text-center login-footer">
                  <LoginFooter showPrivacyPolicy={showPrivacyPolicy} setShowPrivacyPolicy={setShowPrivacyPolicy} />
                </p>
              </div>
            </div>
          </div>
          <div className="col-8 d-none d-lg-block pe-0">
            <div className="h-100">
              <div className="bg-cover-container"><div className="bg-cover"></div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
  );
};

export default Login;
